import { Helmet } from "react-helmet";
import Footer from "../../components/shared/Footer";
import Navbar from "../../components/shared/Navbar";
import RightBar from "../../components/shared/RightBar";
import Content from "../../components/laporan/Content";
import BreadCrumbLaporan from "../../components/laporan/BreadCrumbLaporan";

export default function Laporan() {
    return (
        <div className="flex flex-col min-h-screen">
            <Helmet>
                <title>Laporan - BPR Palu Anugerah</title>
                <meta name="description" content="Laporan BPR Palu Anugerah." />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Laporan - BPR Palu Anugerah" />
                <meta property="og:description" content="Laporan BPR Palu Anugerah." />
                <meta property="og:type" content="website" />
            </Helmet>
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <BreadCrumbLaporan></BreadCrumbLaporan>
                <Content></Content>
            </main>
            <Footer />
        </div>
    )
}